import { render, staticRenderFns } from "./Genitori.vue?vue&type=template&id=5e73ce92"
import script from "./Genitori.vue?vue&type=script&lang=js"
export * from "./Genitori.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports